import { Colors } from "../../consts/Colors";
import FONTS from "../../consts/Fonts";
import ButtonDecor from "./pointandclick/ButtonDecor";

export default class ChoixText extends Phaser.GameObjects.Container {
    constructor(scene, x, y, config, endFunc) {
        super(scene, x, y);
        this.scene = scene;
        scene.add.existing(this);

        this.config = config;
        this.endFunc = endFunc;
        this.currentIndex = 0;

        this.addBody()
        this.setSize(this.background.width, this.background.height);
    }

    addBody(){

        // Ajout du fond
        this.background = this.scene.add.image(0, 0, 'choix_text_background').setOrigin(0.5);
        this.add(this.background);

        // Ajout du texte
        this.textElmt = this.scene.add.text(0, 0, this.config[this.currentIndex].text, {
            fontSize: '22px',
            fontFamily: FONTS.InterSemiBold,
            color: Colors.Text.Black
        }).setOrigin(0.5);
        this.add(this.textElmt);

        // Ajout bouton gauche
        this.leftButton = new ButtonDecor(this.scene, -270, 0, -1)
        this.leftButton.textElmt.setText("⬅")
        this.add(this.leftButton);
        this.leftButton.setClickFunction( () => {
            this.onLeftClick();
        })

        // Ajout bouton droit
        this.rightButton = new ButtonDecor(this.scene, 270, 0, -1)
        this.rightButton.textElmt.setText("⮕")
        this.add(this.rightButton);
        this.rightButton.setClickFunction( () => {
            this.onRightClick();
        })
    }

    onLeftClick(){
        this.currentIndex = (this.currentIndex - 1 + this.config.length) % this.config.length;

        let tmpText = this.scene.add.text(50, 0, this.config[this.currentIndex].text, {
            fontSize: '22px',
            fontFamily: FONTS.InterSemiBold,
            color: Colors.Text.Black
        }).setOrigin(0.5);
        tmpText.alpha = 0;
        this.add(tmpText);

        this.scene.tweens.add({
            targets: this.textElmt,
            alpha: 0,
            x: '-=50',
            duration: 200,
            ease: 'Cubic.easeInOut',
            onComplete: () => {
                this.textElmt.destroy();
                this.textElmt = tmpText;
                if(this.endFunc)
                    this.endFunc();
            }
        });

        this.scene.tweens.add({
            targets: tmpText,
            alpha: 1,
            x: '-=50',
            duration: 200,
            ease: 'Cubic.easeInOut'
        });
    }

    onRightClick(){
        this.currentIndex = (this.currentIndex + 1) % this.config.length;

        let tmpText = this.scene.add.text(-50, 0, this.config[this.currentIndex].text, {
            fontSize: '22px',
            fontFamily: FONTS.InterSemiBold,
            color: Colors.Text.Black
        }).setOrigin(0.5);
        tmpText.alpha = 0;
        this.add(tmpText);

        this.scene.tweens.add({
            targets: this.textElmt,
            alpha: 0,
            x: '+=50',
            duration: 200,
            ease: 'Cubic.easeInOut',
            onComplete: () => {
                this.textElmt.destroy();
                this.textElmt = tmpText;
                if(this.endFunc)
                    this.endFunc();
            }
        });

        this.scene.tweens.add({
            targets: tmpText,
            alpha: 1,
            x: '+=50',
            duration: 200,
            ease: 'Cubic.easeInOut'
        });
    }

    isTrue(){
        return this.config[this.currentIndex].isTrue;
    }

    hideButtons(){
        this.leftButton.setVisible(false);
        this.rightButton.setVisible(false);
    }

    showButtons(){
        this.leftButton.setVisible(true);
        this.rightButton.setVisible(true);
    }
}